import React, { useCallback, useEffect, useRef, useState } from 'react';
import Icon, { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import {
  Avatar,
  Button, Checkbox,
  Col,
  Flex,
  Form, Input,
  message,
  Row,
  Select, Spin,
} from 'antd';
import { DeleteRedBtn } from '../../assets/image/svg';
import './style.scss';
import TextArea from 'antd/es/input/TextArea';
import NumericInput from '../../components/NumericInput/NumericInput';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../store';
import { Utils } from '../../utils';
import { commentAll, commentDelete, searchLocation, setBet, updateBet } from '../../store/bids';
import { IBet } from '../../types';
import moment from 'moment/moment';
import DrawerComponent from '../../components/DrawerComponent';
import FormComment from './formComment';
import Tooltips from './tooltips';
import { IPagination } from '../../components/tableComponent/Table';
import { useLocation } from 'react-router-dom';
import { SessionStorageManager } from '../../components/tableComponent/sessionStorageManager';
import Cookies from 'js-cookie';
import InputComponent from '../../components/inputComponent';
import { suffixSelectorCrane, suffixSelectorDay, suffixSelector } from './symbol';
import { useTranslation } from 'react-i18next';

interface FormNewBetProps {
  dataRows?: any,
  isTypeForm: boolean,
  setDataAllBids?: (value: any) => void,
  closeForm?: () => void,
  pagination: IPagination<any>,
  setCity1: (value: (((prevState: []) => []) | [])) => void,
  setCity2: (value: (((prevState: []) => []) | [])) => void,
  dataCity1: [],
  dataCity2: []
}

const FormNewBet = ({ dataRows, isTypeForm, closeForm, setCity1, setCity2, dataCity1, dataCity2 }: FormNewBetProps) => {
  const [form] = Form.useForm();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const location = useLocation();
  const inputRef = useRef(null);
  const [valueKtk, setValueKtk] = useState(0);
  const [valueBet, setValueBet] = useState<string | null>(null);
  const [valueFreeDays, setValueFreeDays] = useState(0);
  const [valueCNP, setValueCNP] = useState(0);
  const [department, setDepartment] = useState<any>(t('Sales'));
  const [subsidy, setSubsidy] = useState<boolean>(false);
  const [nameCountry1, setNameCountry1] = useState<string | null>(null);
  const [nameCountry2, setNameCountry2] = useState<string | null>(null);
  const [nameCity1, setNameCity1] = useState<string | null>(null);
  const [nameCity2, setNameCity2] = useState<string | null>(null);
  const [localeDepartment, setLocaleDepartment] = useState<any[]>([]);
  const [localeQuality, setLocaleQuality] = useState<any[]>([]);
  const dataTypeQuality = useSelector((state: RootState) => state.resources.dataTypeQuality);
  const dataTypeQualityEn = useSelector((state: RootState) => state.resources.dataTypeQualityEn);
  const dataTypeContainers = useSelector((state: RootState) => state.resources.dataTypeContainers);
  const dataTypeDepartment: any = useSelector((state: RootState) => state.resources.dataTypeDepartment);
  const dataTypeDepartmentEn: any = useSelector((state: RootState) => state.resources.dataTypeDepartmentEn);
  const [openDrawerComment, setOpenDrawerComment] = useState<boolean>(false);
  const dataCommentAll = useSelector((state: RootState) => state.bids.dataCommentAll);
  const [avatar, setAvatar] = useState<string | null>(null);
  const [avatarText, setAvatarText] = useState<string | null>(null);
  const [fetching, setFetching] = useState(false);
  const storageManager = new SessionStorageManager(location.pathname);
  const storageLocal: any = storageManager.getItem();
  const locale = localStorage.getItem('i18nextLng');
  const { bet, bet_int } = dataRows?.[0] || {};

  const handleDataRowsChange = useCallback(() => {
    if (dataRows.length > 0 && dataRows[0] !== null) {
      const currentId = dataRows[0].id;
      dispatch(commentAll({ id: currentId, locale: locale }));
      setDepartment(dataRows[0].department);
    } else {
      setDepartment(t('Sales'));
    }
  }, [dataRows]);

  const handleAvatar = useCallback(() => {
    setAvatar(dataRows?.[0]?.users?.avatar);
    setAvatarText(dataRows?.[0]?.users?.fio.substring(0, 2).toUpperCase());
  }, [dataRows]);

  useEffect(() => {
    setSubsidy(false);
    setDepartment(dataRows.length > 0 ? dataRows[0].department : t('Sales'));
    const locale = localStorage.getItem('i18nextLng');

    if (locale === 'en') {
      setLocaleDepartment(dataTypeDepartmentEn);
      setLocaleQuality(dataTypeQualityEn)
    } else {
      setLocaleDepartment(dataTypeDepartment);
      setLocaleQuality(dataTypeQuality)
    }
    if (dataRows?.[0]?.subsidy === t('Subsidy')) {
      setSubsidy(true);
    } else {
      setSubsidy(false);
    }
    setValueBet(bet_int)
    form.setFieldsValue({
      symbolCrane: dataRows.length > 0 ? dataRows[0].symbolCrane : 'RUB',
      symbolDay: dataRows.length > 0 ? dataRows[0].symbolDay : 'RUB',
      symbol: dataRows.length > 0 ? dataRows[0].symbol : 'RUB',
      comment: null,
      department: dataRows.length > 0 ? dataRows[0].department : t('Sales'),
      location1: dataRows.length > 0 ? dataRows[0].city1 : null,
      cities: dataRows.length > 0 ? dataRows.map((row: any) => ({ add_city: row.city2 })) :
        { add_city: null },
      col_ktk: dataRows.length > 0 && dataRows[0].col_ktk ? dataRows[0].col_ktk : 0,
      type_ktk: dataRows.length > 0
        ? dataRows[0].type_ktk
        : dataTypeContainers?.[0]?.label,
      bet: bet === 'По запросу' ? '0' :
          bet === null ? bet_int :
              bet,
      bet_1_crane: !dataRows.length || !dataRows?.[0]?.bet_1_crane ? '0' : dataRows?.[0]?.bet_1_crane,
      bet_1_day: !dataRows.length || !dataRows?.[0]?.bet_1_day ? '0' : dataRows?.[0]?.bet_1_day,
      quality: dataRows.length > 0 ? dataRows[0].quality : dataTypeQuality?.[0]?.label,
      free_days: dataRows.length > 0 && dataRows[0].free_days
        ? dataRows[0].free_days
        : 0,
      cnp: dataRows.length > 0 && dataRows[0].cnp ? dataRows[0].cnp : 0,
    });
    handleDataRowsChange();
    handleAvatar();

    if (dataRows.length > 0) {
      setNameCountry1(
        dataRows?.[0]?.country1 !== null ? dataRows?.[0]?.country1 + ',' : '',
      );
      setNameCity1(dataRows?.[0]?.city1 !== null ? dataRows?.[0]?.city1 : '');
      setNameCountry2(
        dataRows?.[0]?.country2 !== null ? dataRows?.[0]?.country2 + ',' : '',
      );
      setNameCity2(dataRows?.[0]?.city2 !== null ? dataRows?.[0]?.city2 : '');
    } else {
      clearLocation();
    }
  }, [
    dataRows,
    dataTypeContainers,
    dataTypeQuality,
    dataTypeQualityEn,
    form,
    handleDataRowsChange,
    handleAvatar,
    dataTypeDepartmentEn,
    dataTypeDepartment,
  ]);

  const clearLocation = () => {
    setNameCountry1(null);
    setNameCountry2(null);
    setNameCity1(null);
    setNameCity2(null);
  };

  const onFinish = (data: IBet) => {
    if (nameCountry1) {
      data.country1 =
        nameCountry1?.replace(',', '') !== ''
          ? nameCountry1?.replace(',', '')
          : dataRows.country1;
      data.city1 = nameCity1 !== null ? nameCity1 : dataRows.city1;
    } else {
      data.country1 = null;
      data.city1 = null;
    }
    data.user_id = Utils.decrypt(sessionStorage.getItem('_yl105000')).id;
    console.log(data)
    data.updated_at = new Date();
    data.comment = data.comment !== null || true ? data.comment :
      dataRows.comment;
    if (department === t('Rent') || department === t('Terminals')) {
      if (nameCountry2) {
        data.country2 =
          nameCountry2?.replace(',', '') !== ''
            ? nameCountry2?.replace(',', '')
            : dataRows.country2;
        data.city2 = nameCity2 !== null ? nameCity2 : dataRows.city2;
      } else {
        data.country2 = null;
        data.city2 = null;
      }
    } else {
      data.country2 = null;
      data.city2 = null;
      data.col_ktk = 0;
      data.free_days = 0;
      data.cnp = 0;
    }
    setNameCountry1(null);
    setNameCountry2(null);
    data.is_archive = false;
    data.subsidy = subsidy ? t('Subsidy') : null;
    data.locale = locale;

    data.bet = data.bet === '0' || data.bet === '' || data.bet === null ? 'По запросу' : valueBet;
    data.bet_1_crane = data.bet_1_crane === '0' ? null : data.bet_1_crane;
    data.bet_1_day = data.bet_1_day === '0' ? null : data.bet_1_day;
    if (data.department === t('Rent') || data.department === t('Sales')) {
      if (data.symbol === '' || data.bet === '0' || data.bet === '') {
        data.symbol = null;
      }
      data.symbolCrane = null;
      data.bet_1_crane = null;
      data.symbolDay = null;
      data.bet_1_day = null;
    }

    if (data.department === t('Terminals')) {
      if (data.symbolCrane === '' || data.symbolCrane === null || data.bet_1_crane === '' || data.bet_1_crane === null) {
        data.symbolCrane = null;
      }
      if (data.symbolDay === '' || data.symbolDay === null || data.bet_1_day === '' || data.bet_1_day === null) {
        data.symbolDay = null;
      }
      data.symbol = null;
      data.bet = null;
    }


    if (isTypeForm) {
      if (storageLocal) {
        data.page = storageLocal.pagination.page;
        data.current = 1;
      } else {
        data.page = 10;
        data.current = 1;
      }
      data.created_at = new Date();

      dispatch(setBet(data));
    } else {
      if (dataRows.length > 0) {
        data.id = dataRows[0].id;
        data.created_at = dataRows?.created_at;
        dispatch(updateBet(data));
      } else {
        message.error(t('ImpossibleSave'));
      }
    }

    form.resetFields();
    if (closeForm) {
      closeForm();
    }
  };

  const closeForms = () => {
    clearLocation();
    if (closeForm) {
      closeForm();
    }
    form.resetFields();
  };

  const onSearchLocation = async (value: string, startEnd: boolean) => {
    if (value?.length >= 2) {
      dispatch(searchLocation({ value: value, locale: locale })).then((response: any) => {
        if (startEnd) {
          setCity1(response.payload);
        } else {
          setCity2(response.payload);
        }
      });
    }
  };

  const onSelectLocation = (e: any, type: 'start' | 'end') => {
    if (e) {
      if (type === 'start') {
        setNameCountry1(e.country);
        setNameCity1(e.city);
      } else {
        setNameCountry2(e.country);
        setNameCity2(e.city);
      }
    } else {
      setNameCountry1(null);
      setNameCity1(null);
    }
  };

  const onChangeLocation = (e: any, type: 'start' | 'end') => {
    if (!e || e === '') {
      if (type === 'start') {
        setNameCountry1(null);
        setNameCity1(null);
      } else {
        setNameCountry2(null);
        setNameCity2(null);
      }
    }
  };

  const handleDepartmentChange = (value: string) => {
    setDepartment(value);
  };

  const deleteComment = (id: number) => {
    dispatch(commentDelete({ id: id, bet_id: dataRows[0].id, locale: locale }));
  };

  const handleComment = () => {
    setOpenDrawerComment(true);
  };

  const closeFormViewComment = () => {
    setOpenDrawerComment(false);
  };

  const onClickNumericInput = () => {
  };

  const renderLocationInput = (
    label: string, name: string, onSelect: any, onSearch: any, onChange: any, options: any,
    tooltipTitle: any) => (
    <Tooltips title={nameCountry1 || nameCity1 ? tooltipTitle : ''}>
      <Form.Item label={label} name={name} style={{ width: '100%', alignSelf: 'flex-start' }}
                 rules={[{ required: true, message: t('RequiredField') }]}>
        <Select
          showSearch
          allowClear
          onSelect={onSelect}
          onSearch={onSearch}
          onChange={onChange}
          notFoundContent={fetching ? <Spin size="small" /> : null}
          options={options.map((d: any) => (
            {
              value: d.country + ' ' + d.city,
              label: d.country + ' ' + d.city,
              country: d.country,
              city: d.city,
            }
          ))}
        />
      </Form.Item>
    </Tooltips>
  );

  const renderNumericInput = (label: string, name: string, value: any, onChange: any) => (
    <Form.Item label={label} name={name} style={getDepartmentStyle()}>
      <NumericInput
        onClear={onClickNumericInput}
        ref={inputRef}
        style={{ width: '100%' }}
        value={value}
        onChange={onChange}
        maxLength={4}
        placeholder=""
      />
    </Form.Item>
  );

  const renderSelect = (label: string, name: string, option: any) => (
    <Form.Item label={label} name={name} style={getDepartmentStyle()}>
      <Select
        value={option?.[0]?.label}
        style={{ width: '100%' }}
        options={option}
      />
    </Form.Item>
  );

  const handleSubsidy = (e: any) => {
    setSubsidy(e.target.checked);
  };

  const renderInput = (label: string, name: string, value: any, onChange: any) => (
    <Tooltips title={value}>
      <Form.Item label={label} name={name} style={name === 'bet' ?
        { width: '45%', top: 11, position: 'relative' } :
        { width: '45%' }}>
        <NumericInput allowClear value={value} onChange={onChange} selectAfter={suffixSelector} />
        {
          (department === t('Sales') || department === t('Rent')) && (
            <Checkbox checked={subsidy} onChange={handleSubsidy}>{t('Subsidy')}</Checkbox>
          )
        }
      </Form.Item>
    </Tooltips>
  );

  const renderInputCrane = (label: string, name: string, value: any, onChange: any) => (
    <Tooltips title={value}>
      <Form.Item label={label} name={name} style={{ width: '30%' }}>
        <InputComponent allowClear value={value} onChange={onChange} selectAfter={suffixSelectorCrane} />
      </Form.Item>
    </Tooltips>
  );

  const renderInputDay = (label: string, name: string, value: any, onChange: any) => (
    <Tooltips title={value}>
      <Form.Item label={label} name={name} style={{ width: '30%' }}>
        <InputComponent allowClear value={value} onChange={onChange} selectAfter={suffixSelectorDay} />
      </Form.Item>
    </Tooltips>
  );

  const getDepartmentStyle = () => {
    return department === t('Terminals')
      ? { width: '30%' }
      : { width: '30%' };
  };

  return (
    <>
      <Flex justify="space-between" className={'header-bet_new'} align={'center'}>
        <div className={'fz-20'}>
          {isTypeForm ? t('NewBidCreation') : t('Editing')}
        </div>
      </Flex>
      <Form className={'content__bet'} layout="vertical" autoComplete="off" onFinish={onFinish} form={form}
            initialValues={{
              cities: [{ add_city: null }],
            }}>
        <Flex vertical gap={15}>
          {/* Выберите отдел*/}
          <Form.Item label={t('SelectDepartment')} name={'department'}>
            <Select
              value={dataRows.length > 0 ? dataRows[0].department :
                localeDepartment?.[0]}
              style={{ width: 145 }}
              onChange={handleDepartmentChange}
              options={localeDepartment}
            />
          </Form.Item>

          {/* Локация */}
          <Flex className={'address__box'} justify={'space-between'} align={'center'}>
            {renderLocationInput(t('Location1'), 'location1',
              (e: any, record: any) => onSelectLocation(record, 'start'),
              (e: any) => onSearchLocation(e, true),
              (e: any) => onChangeLocation(e, 'start'),
              dataCity1, `${nameCountry1} ${nameCity1}`)}
            {(department === t('Rent')) &&
              <Col span={12} style={{ paddingRight: 0 }}>
                <Form.List name="cities">
                  {(fields, { add, remove }) => (
                    <>
                      {fields.map(({ key, name, ...restField }) => (
                        <Flex gap={13} key={key}>
                          <Form.Item
                            {...restField}
                            style={{ width: '100%' }}
                            name={[name, 'add_city']}
                            label={key === 0 && t('Location2')}
                          >
                            <Select
                              showSearch
                              allowClear
                              onSelect={(e: any, record: any) => onSelectLocation(record, 'end')}
                              onSearch={(e: any) => onSearchLocation(e, false)}
                              onChange={(e: any) => onChangeLocation(e, 'end')}
                              notFoundContent={fetching ? <Spin size="small" /> : null}
                              options={dataCity2.map((d: any) => ({
                                value: d.country + ' ' + d.city,
                                label: d.country + ' ' + d.city,
                                country: d.country,
                                city: d.city,
                              }))}
                            />
                          </Form.Item>

                          <Flex gap={5} style={key > 0 ? { maxHeight: 29 } : {}}>
                            {key > 0 &&
                              <DeleteOutlined
                                onClick={() => remove(name)}
                                hidden={!name}
                                style={{
                                  fontSize: '16px',
                                  color: '#D91528',
                                  cursor: 'pointer',
                                }}
                              />
                            }
                            {department === t('Rent') &&
                              <PlusOutlined
                                style={{
                                  fontSize: '16px',
                                  color: '#00B288',
                                  cursor: 'pointer',
                                }}
                                onClick={() => add()}
                              />
                            }
                          </Flex>
                        </Flex>
                      ))}
                    </>
                  )}
                </Form.List>
              </Col>
            }
          </Flex>

          {/* Количество КТК Тип КТК Ставка */}
          <Flex vertical>
            <Flex justify={'space-between'} align={'center'} gap={32}>
              {
                department === t('Sales') && (
                  <>
                    {renderSelect(t('ContainerType'), 'type_ktk', dataTypeContainers)}
                    {renderInput(t('Bet'), 'bet', valueBet, setValueBet)}
                  </>
                )
              }
              {
                department === t('Rent') && (
                  <>
                    {renderNumericInput(t('CpcNumber'), 'col_ktk', valueKtk, setValueKtk)}
                    {renderSelect(t('ContainerType'), 'type_ktk', dataTypeContainers)}
                    {renderInput(t('Bet'), 'bet', valueBet, setValueBet)}
                  </>
                )
              }
              {
                department === t('Terminals') && (
                  <>
                    {renderSelect(t('ContainerType'), 'type_ktk', dataTypeContainers)}
                    {renderInputCrane(t('RatePerLift'), 'bet_1_crane', valueBet, setValueBet)}
                    {renderInputDay(t('RatePerDay'), 'bet_1_day', valueBet, setValueBet)}
                  </>
                )
              }
            </Flex>

            {/* Состояние и другие поля */}
            <Flex justify={'space-between'} align={'center'} gap={34}>
              {
                department === t('Sales') && (
                  <>
                    {renderSelect(t('Quality'), 'quality', localeQuality)}
                  </>
                )
              }
              {
                department === t('Rent') && (
                  <>
                    {renderNumericInput(t('FreeDays'), 'free_days', valueFreeDays, setValueFreeDays)}
                    {renderNumericInput(t('Overdue'), 'cnp', valueCNP, setValueCNP)}
                  </>
                )
              }
            </Flex>
            <Form.Item name={'link'} label={t('LinkPhoto')} rules={[{ type: 'url' }]}>
              <Input allowClear />
            </Form.Item>
            {/* Комментарий */}
            <Flex vertical gap={16}>
              {!isTypeForm && (
                <Flex vertical>
                  <Flex justify={'space-between'} align={'center'}>
                    <div className={'fz-14'}>{t('Comments')}</div>
                    <div className={'text__blue'} onClick={handleComment}>
                      {t('ViewAll')} ({dataCommentAll.length})
                    </div>
                  </Flex>
                  <div className="comment-selector"
                       style={dataCommentAll.length > 0 ? { maxHeight: 56 } : { minHeight: 56 }}>
                    {dataCommentAll.length > 0 && (
                      <Row className={'comment-wrapper'}>
                        <Col span={2}>
                          <Avatar size={32} src={avatar} style={{ top: 6 }}>
                            {avatar === null ? avatarText : dataCommentAll[0]?.users?.fio.slice(0, 2).toUpperCase()}
                          </Avatar>
                        </Col>
                        <Col span={18}>
                          <Flex gap={6} vertical>
                            <div className={'fz-14'}>{dataCommentAll?.[0]?.users?.fio}</div>
                            <div className={'fz-12'}>{dataCommentAll?.[0]?.text}</div>
                          </Flex>
                        </Col>
                        <Col span={4}>
                          <Flex gap={6} align={'center'}>
                            <div className={'text__date'}>
                              {moment(dataCommentAll[0]?.created_at).format('DD.MM.YYYY')}
                            </div>
                            <Icon component={DeleteRedBtn} onClick={() => deleteComment(dataCommentAll[0]?.id)} />
                          </Flex>
                        </Col>
                      </Row>
                    )}
                  </div>
                </Flex>
              )}
              <Form.Item label={t('WriteComment')} name={'comment'}>
                <TextArea showCount maxLength={2500} style={{ height: 100, resize: 'none' }} />
              </Form.Item>
            </Flex>
          </Flex>
        </Flex>
        <Flex gap={10} className={'box__save_close'}>
          <Button type={'primary'} block htmlType={'submit'}>
            {isTypeForm ? t('Save') : t('SaveChanges')}
          </Button>
          <Button color="danger" variant="text" style={{ width: 235 }} onClick={closeForms}>
            {t('Cancel')}
          </Button>
        </Flex>
      </Form>
      <DrawerComponent open={openDrawerComment} onClose={closeFormViewComment}>
        <FormComment dataRows={dataRows} />
      </DrawerComponent>
    </>
  );
};

export default FormNewBet;
